import { useState } from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

const CreditUsageBar = ({ reviewsRemaining, totalCredits, creditPercentage }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className={styles.usage}>
      <div className={styles['usage-heading']}>
        <div className={styles.label}>
          Plan usage Limits
        </div>
        <div
          className={styles['help-icon']}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="6.5" stroke="#8F97A5" strokeWidth="1.5" />
            <path d="M8 11V8M8 5H8.01" stroke="#8F97A5" strokeWidth="1.5" strokeLinecap="round" />
          </svg>

          {showTooltip && (
            <div className={styles.tooltip}>
              <div className={styles['tooltip-content']}>
                <div className={styles.breakdown}>
                  <div className={styles.item}>
                    <span className={styles['item-label']}>
                      Single screen audit
                    </span>
                    <span className={styles['item-value']}>
                      1 credit
                    </span>
                  </div>
                  <div className={styles.item}>
                    <span className={styles['item-label']}>
                      Prototype
                    </span>
                    <span className={styles['item-value']}>
                      1 credit
                    </span>
                  </div>
                  <div className={styles.item}>
                    <span className={styles['item-label']}>
                      Flow audit
                    </span>
                    <span className={styles['item-value']}>
                      2 credits
                    </span>
                  </div>
                </div>
                <div className={styles.divider} />
                <div className={styles['tooltip-footer']}>
                  Resets monthly
                </div>
              </div>
              <div className={styles['tooltip-arrow']} />
            </div>
          )}
        </div>
      </div>

      <div className={styles['progress-bar-container']}>
        <div className={styles['progress-labels']}>
          <div className={styles['credits-available']}>
            <span
              className={`${styles.remaining} ${reviewsRemaining === 0 ? styles['remaining-zero'] : ''}`}
            >
              {reviewsRemaining}
            </span>
            <span className={styles['credit-total']}>
              /
              {' '}
              {totalCredits}
              {' '}
              credits
            </span>
          </div>
          <div className={styles.percentage}>
            {Math.round(creditPercentage)}
            % left
          </div>
        </div>

        <div className={styles.bar}>
          <div className={styles['bar-background']} />
          <div
            className={`${styles['bar-fill']} ${creditPercentage <= 0 ? styles.hidden : ''}`}
            style={{ right: `${100 - Math.min(100, creditPercentage)}%` }}
          />
        </div>
      </div>
    </div>
  );
};

CreditUsageBar.propTypes = {
  reviewsRemaining: PropTypes.number.isRequired,
  totalCredits: PropTypes.number.isRequired,
  creditPercentage: PropTypes.number.isRequired,
};

export default CreditUsageBar;
